import { render, staticRenderFns } from "./ModalEditBooking.vue?vue&type=template&id=70f11b64&scoped=true&"
import script from "./ModalEditBooking.vue?vue&type=script&lang=js&"
export * from "./ModalEditBooking.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditBooking.vue?vue&type=style&index=0&id=70f11b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f11b64",
  null
  
)

export default component.exports